// import React from 'react'

// function TicketTransaction() {
//   return (
//     <div>TicketTransaction</div>
//   )
// }

// export default TicketTransaction

import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { injectModels } from "../../../redux/injectModels";
import { AuthService, EventService } from "../../../services";
import { toast } from "react-toastify";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { Table } from "react-bootstrap";
import { TicketService } from "../../../services";
import AutoCompleteDropdown from "../../../components/Common/AutoCompleteDropdown";

const TicketTransaction = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const loginUser = AuthService.getLoginUser();
  const [suggestions, setSuggestions] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [eventSearchName, setEventSearchName] = useState("All");

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    const bootstrapAsync = async () => {
      await getEventData();
      await getAllOrganizerData(eventSearchName);
    };
    bootstrapAsync();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventService.getEventsByUserId(loginUser?.id);
        if (res?.isSuccess && res?.data?.length > 0) {
          const eventList = res?.data?.map((item) => ({
            eventName: item.eventName,
            id: item.id,
          }));
          setEventList(eventList);
          setSuggestions(eventList.map((item) => item.eventName));
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getAllOrganizerData = async (id) => {
    props.application.setLoading(true);
    const userId = loginUser?.id;
    let eventId = "00000000-0000-0000-0000-000000000000";
    if (id && id.length > 5) {
      eventId = id;
    }

    try {
      const res = await TicketService.getAllTicketsTranctionsReports(
        userId,
        eventId
      );
      if (res?.isSuccess) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleSelect = async (selected) => {
    if (selected && selected.length >= 2) {
      setEventSearchName(selected);
      const filetEvent = eventList.filter(
        (item) => item?.eventName?.trim() === selected?.trim()
      );
      if (filetEvent.length > 0) {
        await getAllOrganizerData(filetEvent[0]?.id);
      }
    } else {
      setEventSearchName("All");
      await getAllOrganizerData("All");
    }
  };

  return (
    <React.Fragment>
      <section>
        <section className="subscription-banner p-0">
          <div className="container">
            <h3>Ticket Transactions</h3>
          </div>
        </section>

        <section className="edit-form-table">
          <div className="container">
            <div className="mb-3">
              <div className="row">
                <div className="col-sm-12">
                  <span>Please enter event name</span>
                  <AutoCompleteDropdown
                    suggestions={suggestions}
                    onSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
            {eventSearchName && (
              <React.Fragment>
                <div className="table-responsive">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Order Id</th>
                        <th>Transaction Id</th>
                        <th>Customer Name</th>
                        <th>Event Name</th>
                        <th>Quantity</th>
                        <th>Amount (£)</th>
                        <th>Created On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData && paginatedData.length > 0 ? (
                        <React.Fragment>
                          {paginatedData.map((item, idx) => {
                            return (
                              <tr key={idx}>
                                <td>{calculateSNo(idx)}</td>
                                <td>{item?.id}</td>
                                <td>{item?.transactionId}</td>
                                <td>
                                  <h5>{item?.customerName}</h5>
                                  <h5>{item?.customerEmail}</h5>
                                </td>
                                <td>{item?.eventName} </td>
                                <td>{item?.ticketQuantity} </td>
                                <td>£{formatAmount(item?.amount)}</td>
                                <td>
                                  {item?.createdOn
                                    ? formatDateENGB(item?.createdOn)
                                    : "-"}
                                </td>
                              </tr>
                            );
                          })}
                        </React.Fragment>
                      ) : (
                        <tr>
                          <td colSpan="10 mt-2">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="table-footer">
                  <p className="mb-3">
                    <strong>Total Count: {filteredData.length}</strong>
                  </p>
                  {filteredData.length === 0 ? "" : renderPagination()}
                </div>
              </React.Fragment>
            )}
            {!eventSearchName && (
              <p>Find the ticket transaction by entering the event name.</p>
            )}
          </div>
        </section>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TicketTransaction);
